import { svg } from "lit";
const icon = svg `<path d="M4.77876 33.4938L14.3267 20.1606H22.7113L33.91 7.08697V33.4938H4.77876ZM6.11093 24.4864L4.43359 23.2706L11.0564 14.0068H19.4293L27.0511 5.12109L28.6322 6.49393L20.3866 16.1007H12.1034L6.11093 24.4864ZM8.86518 31.3998H31.816V12.7332L23.6408 22.2545H15.3737L8.86518 31.3998Z" fill="currentColor"/>`;
export default icon;
